/*
@author Nikhil 

jvFocus 
Used to add focus to an element on the page on load
@param jquery selector id/class

Example usage <div jv-focus selector="#jv-navigationSearch"> </div>
 */
angular.module('jv.Common.Directives.Focus', [])

.directive('jvFocus',['$timeout', function($timeout){
     return {
        link: function(scope, iElm, iAttrs, ngModel) {
            var selector  = iAttrs.selector;
            if (parseFloat(jQuery.fn.jquery) <= 1.3) {
                $(selector).focus();
            } else {
                $(selector).trigger('focus');
            }
        }
    };

}]);
